import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

import { requestCode, verifyCode } from '@/services/auth';
import { useAuthStore } from '@/store/auth.store';

export default function Login() {
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const setSession = useAuthStore((s) => s.setSession);

  const onRequest = async (e: React.FormEvent) => {
    e.preventDefault();
    const mail = email.trim();
    if (!mail) return;
    try {
      setBusy(true);
      await requestCode(mail);
      toast.success(import.meta.env.DEV ? 'Код: 123456 (dev)' : 'Код отправлен на почту');
      setStep('code');
    } catch {
      /* toast from interceptor */
    } finally {
      setBusy(false);
    }
  };

  const onVerify = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setBusy(true);
      const res = await verifyCode(email.trim(), code.trim());
      setSession({
        accessToken: res.access_token,
        refreshToken: res.refresh_token,
        manager: res.manager,
      });
      const to = (location.state as { from?: string } | null)?.from ?? '/';
      navigate(to, { replace: true });
    } catch {
      /* toast */
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-dvh flex items-center justify-center p-4 pt-[max(1rem,env(safe-area-inset-top))] pb-[max(1rem,env(safe-area-inset-bottom))]">
      <div className="card w-full max-w-md p-6 sm:p-7">
        <h1 className="text-xl font-semibold mb-1">Кабинет менеджера</h1>
        <p className="text-sm text-ink/55 mb-6">Вход по коду на email</p>

        {step === 'email' ? (
          <form className="space-y-4" onSubmit={onRequest}>
            <div>
              <label className="label">Email</label>
              <input
                className="input"
                type="email"
                autoComplete="email"
                enterKeyHint="go"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
              />
            </div>
            <button className="btn-primary w-full" type="submit" disabled={busy}>
              {busy ? 'Отправляем…' : 'Получить код'}
            </button>
          </form>
        ) : (
          <form className="space-y-4" onSubmit={onVerify}>
            <div>
              <label className="label">Код из письма</label>
              <input
                className="input tracking-widest text-center text-lg"
                inputMode="numeric"
                autoComplete="one-time-code"
                enterKeyHint="done"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                autoFocus
              />
            </div>
            <button className="btn-primary w-full" type="submit" disabled={busy}>
              {busy ? 'Входим…' : 'Войти'}
            </button>
            <button type="button" className="btn-ghost w-full" onClick={() => setStep('email')}>
              Другой email
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
